var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[((_vm.$route.name!=='planForChange')
    &&(_vm.$route.name!=='planForYear')
    &&(_vm.$route.name!=='planForPerMonth')
    &&(_vm.$route.name!=='homePage')
    &&(_vm.$route.name!=='planForBirth')
    &&(_vm.$route.name!=='myPosition'))?_c('nav-bar',{attrs:{"isIos":_vm.isiOS}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }